import { apiWithdrawalRequest } from '@api/apiCall';
import { useToast } from '@hooks';
import { useNavigation } from '@react-navigation/native';
import { getStore } from '@store/storeUtils';
import { useMutation } from '@tanstack/react-query';
import { showErrorOnAPI } from '@utils/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type WithdrawalResponse = Record<string, any>;

interface UseWithdrawalRequestProps {
  onSuccessCallBack: (isSuccess: boolean, data: WithdrawalResponse | undefined) => void;
  // onErrorCallBack?: (error: unknown) => void; // Add this if needed
}

const useWithdrawalRequest = ({ onSuccessCallBack }: UseWithdrawalRequestProps) => {
  const toast = useToast();
  const navigation = useNavigation();
  const { setLoading, setInitialData } = getStore();
  const { t } = useTranslation('common');
  const {
    isLoading: isWithdrawalLoading,
    isSuccess: isWithdrawalSuccess,
    data: withdrawalData,
    isError: isWithdrawalError,
    error: withdrawalError,
    mutate: withdrawRequest,
  } = useMutation({ mutationFn: payload => apiWithdrawalRequest(payload) });

  useEffect(() => {
    setLoading(isWithdrawalLoading);
  }, [isWithdrawalLoading]);

  useEffect(() => {
    onSuccessCallBack(isWithdrawalSuccess, withdrawalData);
  }, [isWithdrawalSuccess, withdrawalData]);

  useEffect(() => {
    showErrorOnAPI(isWithdrawalError, withdrawalError, toast, t, navigation, setInitialData);
  }, [isWithdrawalError, withdrawalError]);

  return { isWithdrawalLoading, withdrawRequest, isWithdrawalError, withdrawalError };
};

export default useWithdrawalRequest;
